module.exports = __webpack_public_path__ + "img/KC_JSJ.8346e80d.png";